import React from 'react';
import Select from 'react-select';
import { getTranslation } from '../../../utils/translation';

const Leagues = props => {
    const { leagues, selectedCategoryId, selectedLeagueId } = props;

    const options = leagues
        .filter(
            league =>
                !league.categoryId ||
                selectedCategoryId === 'all' ||
                league.categoryId === selectedCategoryId
        )
        .map(league => ({
            value: league.id,
            label: league.name,
            selected: league.id === selectedLeagueId,
            categoryId: league.categoryId,
        }));

    const selectedOption = options.find(option => option.selected);

    const onChange = value => {
        if (value.value === selectedOption.value) return;

        if (props.onChange) {
            props.onChange(value);
        }
    };

    return (
        <Select
            className='common-select common-select--events'
            classNamePrefix='common'
            menuPlacement={'auto'}
            value={selectedOption}
            onChange={onChange}
            options={options}
            noOptionsMessage={getTranslation('noOptionsMessage')}
        />
    );
};

export default Leagues;
